/*
 * Tenue — announcement.js
 * Shows the announcement bar messages one at a time.
 */
(function () {
  'use strict';

  if (customElements.get('announcement-rotator')) return;

  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('[data-message]'));
      if (this.messages.length < 2) return;
      this.index = Math.max(0, this.messages.findIndex((message) => message.hasAttribute('data-active')));
      this.delay = (parseInt(this.dataset.speed, 10) || 5) * 1000;

      ['mouseenter', 'focusin'].forEach((type) => this.addEventListener(type, () => this.stop()));
      ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => this.start()));

      // In the theme editor, show the message whose block is selected.
      this.messages.forEach((message, index) => {
        message.addEventListener('shopify:block:select', () => {
          this.stop();
          this.show(index);
        });
        message.addEventListener('shopify:block:deselect', () => this.start());
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.show(this.index + 1), this.delay);
    }

    stop() {
      clearInterval(this.timer);
    }

    show(index) {
      const current = this.messages[this.index];
      current.removeAttribute('data-active');
      current.inert = true;
      this.index = (index + this.messages.length) % this.messages.length;
      const next = this.messages[this.index];
      next.setAttribute('data-active', '');
      next.inert = false;
    }
  }

  customElements.define('announcement-rotator', AnnouncementRotator);
})();
